import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Loading from '../../common/components/Loading';
import { getCourse, getCourses } from './redux/actions';
import { selectCourse, selectCourses } from './redux/selectors';
import CourseOverview from './views/CourseOverview';
import Chapter from './views/Chapter';
import Lesson from './views/Lesson';
import LessonComplete from './views/LessonComplete';

class Course extends Component {
  static propTypes = {
    course: PropTypes.object,
    courses: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.props.dispatch(getCourse(this.props.match.params.courseId));
    if (!this.props.courses) {
      this.props.dispatch(getCourses());
    }
  }

  componentWillUpdate(nextProps) {
    if (nextProps.match.params.courseId !== this.props.match.params.courseId) {
      this.props.dispatch(getCourse(nextProps.match.params.courseId));
    }

    if (!this.props.courseError && nextProps.courseError) {
      if (nextProps.courseError.get('message') === 'no_access') {
        this.props.history.push('/subscription/billing');
      } else {
        this.props.history.replace('/subscription/courses');
      }
    }
  }

  render() {
    const { course, courses, match } = this.props;

    if (!course || !courses) {
      return <Loading />;
    }

    return (
      <div>
        <Helmet>
          <title>Tathata Golf - Courses</title>
        </Helmet>
        <Switch>
          <Route exact path={`${match.path}`} component={CourseOverview} />
          <Route exact path={`${match.path}/chapters/:chapterId`} component={Chapter} />
          <Route exact path={`${match.path}/chapters/:chapterId/lessons/:lessonId`} component={Lesson} />
          <Route
            exact
            path={`${match.path}/chapters/:chapterId/lessons/:lessonId/complete`}
            component={LessonComplete}
          />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  courseError: state.subscription.courses.course.get('error'),
  course: selectCourse(state, props),
  courses: selectCourses(state),
});

export default connect(mapStateToProps)(Course);



// WEBPACK FOOTER //
// ./src/subscription/courses/Course.js